










import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';
import YesNoInput from '@/Components/Input/YesNoInput.vue';

@Component({
    components: {YesNoInput},
})
export default class YesNoOtherInput extends Vue {
    static COMPONENT_NAME = 'yes-no-other-input'

    @Prop({type: String, default: 'some'}) otherValue!: string;
    @Prop({type: String, default: 'Some'}) otherLabel!: string;

    get options(): Record<string, string> {
        return {
            [this.otherValue]: this.otherLabel,
        }
    }

}
